import { render, staticRenderFns } from "./ProfessionalReview.vue?vue&type=template&id=f95cf16c&scoped=true"
import script from "./ProfessionalReview.vue?vue&type=script&lang=js"
export * from "./ProfessionalReview.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalReview.vue?vue&type=style&index=0&id=f95cf16c&prod&scoped=true&lang=css"
import style1 from "./ProfessionalReview.vue?vue&type=style&index=1&id=f95cf16c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95cf16c",
  null
  
)

export default component.exports